import axios from "axios";

export default axios.create({
  baseURL: "https://inventory-of-supplies.herokuapp.com",
  withCredentials: true
});
